import { render, staticRenderFns } from "./EcnHeartBeat.vue?vue&type=template&id=48bee1d2&"
import script from "./EcnHeartBeat.vue?vue&type=script&lang=js&"
export * from "./EcnHeartBeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports